export const SimpleTextThumbnail = () => (
  <svg
    viewBox="0 0 160 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    preserveAspectRatio="xMidYMid meet"
    aria-hidden="true"
  >
    {/* Simple text icon - just lines representing text */}
    <rect x="30" y="16" width="100" height="10" rx="3" fill="#7986cb" />
    <rect x="30" y="34" width="60" height="8" rx="3" fill="#5c6bc0" />
  </svg>
);
